const countString = (str: string): number => {
    return str.length;
};

export default countString;